import { Vue, Component, Prop } from "vue-property-decorator";
import Vue2TouchEvents from 'vue2-touch-events';

Vue.use(Vue2TouchEvents);


interface IMediaItem {
    thumb: string;
    url: string;
    type: string;
    imageSize: {
        width: number;
        height: number;
    }
}

interface ILightbox {
    src: string | null,
    next: number | null,
    previous: number | null,
    show: boolean
}

@Component
export default class Lightbox extends Vue {
    private _items: Array<IMediaItem> = [];

    public src: string = '';
    public height: number;
    public width: number;

    public current: number = 0;
    public show: boolean = false;
    public navPrevDisabled: boolean = false;
    public navNextDisabled: boolean = false;

    constructor() {
        super();
    }

    mounted() {
        this.$parent.$on('show-lightbox', this.Open);
        this.$parent.$on('show-lightbox-single', this.OpenSingle);
    }

    public Open(current: number, items: Array<IMediaItem>): void {
        this._items = items;
        this.current = current;
        this.ShowItem();
        this.show = true;
    }

    public OpenSingle(url: string): void {
        this._items = [{
            url: url,
            thumb: '',
            type: 'image'
        } as IMediaItem];
        this.current = 0;
        this.ShowItem();
        this.show = true;
    }

    public Hide(): void {
        this.show = false;
    }

    public ShowItem(): void {

        var item = this._items[this.current]

        this.src = item.url;

        if (item.imageSize) {
            this.height = item.imageSize.height;
            this.width = item.imageSize.width;
        }
        this.navPrevDisabled = this.current < 1;
        this.navNextDisabled = this.current > this._items.length - 2;
    }

    public Previous(): void {
        if (this.navPrevDisabled) {
            return;
        }
        this.current--;
        this.ShowItem();
    }

    public Next(): void {
        if (this.navNextDisabled) {
            return;
        }
        this.current++;
        this.ShowItem();
    }
}




// WEBPACK FOOTER //
// ./www/js/Components/Lightbox/Lightbox.ts